module.exports = __webpack_public_path__ + "octopus-service-440.994251f1ff051a53d400f375c18d4e9b.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/users/octopus-service-440.png
// module id = 3701234901114624
// module chunks = 1